/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MsftButton',['pixi', 'absolute', 'lodash', 'absolute/stringmanager'],

    function (PIXI, Absolute, _, StringManager) {

        var MsftButton = function (options) {
            this._initMsftButton(options);
        };

        MsftButton.constructor = MsftButton;
        MsftButton.prototype = Object.create(PIXI.Sprite.prototype);

        MsftButton.prototype._initMsftButton = function (options) {


            this.options = options;


            this.container = new PIXI.DisplayObjectContainer();

            // create up state
            this.upTexture = this._createTexture(this.options.threeSlice, 'up');
            this.overTexture = this._createTexture(this.options.threeSlice, 'over');
            this.downTexture = this._createTexture(this.options.threeSlice, 'down');

            PIXI.Sprite.call(this, this.upTexture);

            this.interactive = true;
            this.buttonMode = true;
            this._hasFocus = false;

            this.focusIndicator = new PIXI.Graphics();
            this.focusIndicator.lineStyle(1, 0xFFFFFF);
            var margin = Absolute.Coords.x(2);
            this.focusIndicator.drawRect(margin, margin, this.width - 2 * margin, this.height - 2 * margin);


            if (Absolute.Platform.supportsTouch()) {

                this.touchstart = function (evt) {
                    this.setTexture(this.downTexture);
                };

                this.touchend = function (evt) {
                    this.setTexture(this.upTexture);
                    this.handleAction();
                };

                this.touchendoutside = function (evt) {
                    this.setTexture(this.upTexture);
                };

                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    this.bindMouseEvents();
                }

            } else {
                this.bindMouseEvents();
            }
        };

        MsftButton.prototype.createBorder = function () {
            var border = new PIXI.Graphics();
            border.beginFill(this.options.border.color);
            border.drawRect(
                0, 0,
                this.options.width + this.options.border.thickness + Absolute.Coords.x(2),
                this.options.minHeight + this.options.border.thickness
            );
            border.endFill();
            return border;
        };

        MsftButton.prototype.bindMouseEvents = function () {

            this.mouseover = function (evt) {
                this.setTexture(this.overTexture);
            };
            this.mouseout = function (evt) {
                this.setTexture(this.upTexture);
            };

            this.mousedown = function (evt) {
                this.setTexture(this.downTexture);
            }.bind(this);

            this.mouseup = function (evt) {
                this.setTexture(this.upTexture);
                this.handleAction();
            }.bind(this);
        };

        MsftButton.prototype.handleActivate = function () {
            this.handleAction();
        };

        MsftButton.prototype.handleAction = function () {
            Absolute.AudioManager.playSound('button');
            this.options.action();
        };

        MsftButton.prototype._createTexture = function (threeSliceOptions, type) {

            var container = new PIXI.DisplayObjectContainer(),
                threeSlice;


            var tso = {
                width: this.options.width,
                height: this.options.height,
                minHeight: this.options.minHeight,
                images: {
                    left: threeSliceOptions.images.left,
                    center: threeSliceOptions.images.center,
                    right: threeSliceOptions.images.right
                }
            };

            var style = {
                font: this.options.letterStyle.font,
                align: 'center',
                fill: this.options.letterStyle.fill
            };

            if (threeSliceOptions.multistate) {
                var suffix = "";
                if (type === "down") {
                    suffix = "_down";
                    if (!this.options.keepTintOnDown) {
                        style.fill = style.fill == '#ffffff' ? '#1' : '#ffffff';
                        if (this.options.downFill) style.fill = this.options.downFill;
                    }
                } else if (type === "over") {
                    suffix = "_hover"
                }

                tso.images.left = threeSliceOptions.images.left.split(".")[0] + suffix + ".png";
                tso.images.center = threeSliceOptions.images.center.split(".")[0] + suffix + ".png";
                tso.images.right = threeSliceOptions.images.right.split(".")[0] + suffix + ".png";
            }

            threeSlice = new Absolute.ThreeSlice(tso);
            if (this.options && this.options.minHeight) {
                threeSlice.height = this.options.minHeight
            }
            var labelText = new PIXI.Text(this.options.text, style),
                buttonTexture;
            var fontSize = StringManager.extractNumbersFromString(style.font);
            StringManager.shrinkToFit(labelText, fontSize, '', this.options.maxWidth);
            var label = new PIXI.Sprite(labelText.generateTexture());
            label.anchor.x = label.anchor.y = 0.5;
            label.x = this.options.width / 2;
            label.y = threeSlice.height / 2 + Absolute.Coords.y(3);

            if (this.options.backgroundColor) threeSlice.tint = parseInt(this.options.backgroundColor);
            if (this.options.border) {
                var border = this.createBorder();
                threeSlice.x = border.x + (border.width - threeSlice.width) / 2;
                threeSlice.y = border.y + (border.height - threeSlice.height) / 2;
                label.x = threeSlice.x + (threeSlice.width) / 2;
                label.y = threeSlice.y + Absolute.Coords.y(2) + (threeSlice.height) / 2;
                container.addChild(border);
            }

            container.addChild(threeSlice);
            container.addChild(label);

            buttonTexture = container.generateTexture();

            threeSlice.destroy();

            return buttonTexture;
        };

        MsftButton.prototype.destroy = function () {
        };

        MsftButton.prototype._focusChanged = function () {
            if (this._hasFocus) {
                this.setTexture(this.overTexture);
                this.addChild(this.focusIndicator);
            } else {
                if (this.children.indexOf(this.focusIndicator) != -1) {
                    this.setTexture(this.upTexture);
                    this.removeChild(this.focusIndicator);
                }
            }
        };

        Object.defineProperty(MsftButton.prototype, "focus", {
            get: function () {
                return this._hasFocus;
            },
            set: function (value) {
                this._hasFocus = value;
                this._focusChanged();
                return value;
            }
        });


        return MsftButton;

    });

